import type { CarrierObj } from '#/locale';
import { setCarrierObjFun } from '@/store/locale';
export const convertChangeDataTurn = (airlineList: string | any[]) => {
	let carrierObj: CarrierObj = {} as CarrierObj;
	for (var i = 0; i < airlineList.length; i++) {
		carrierObj[airlineList[i].airlineCode2] = {
			airlineNameCn: airlineList[i].airlineNameCn,
			airlineNameEn: airlineList[i].airlineNameEn,
			airlineNameHk: airlineList[i].airlineNameHk,
			airlineNameJa: airlineList[i].airlineNameJa,
			airlineNameKo: airlineList[i].airlineNameKo,
		};
	}
	setCarrierObjFun(carrierObj);
};
